// frontend/src/components/CarAnimation.jsx
import React from "react";

const CarAnimation = () => {
  return (
    <section className="relative w-full h-[30vh] overflow-hidden">
      {/* Trees background */}
      <div className="absolute bottom-[50px] left-0 w-[300%] h-[100px] bg-[url('https://i.ibb.co/0FQTxN0/trees.png')] bg-bottom bg-contain animate-trees z-10"></div>

      {/* Highway */}
      <div className="absolute bottom-0 left-0 w-[500%] h-[200px] bg-[url('https://us.123rf.com/450wm/andreykuzmin/andreykuzmin1605/andreykuzmin160500066/56495798-asphalt-highway-road-marks-top-view.jpg')] bg-repeat-x animate-highway z-20"></div>

      {/* Car */}
      <div className="absolute left-1/2 bottom-[50px] w-[500px] -translate-x-1/2 animate-car-bounce z-30">
        {/* Car image */}
        <img
          src="https://www.aartiinformatics.com/wp-content/uploads/2014/09/new-sports-car.png"
          className="w-full relative z-30 drop-shadow-[0_10px_10px_rgba(0,0,0,0.3)]"
          alt="Moving Car"
        />

        {/* Wheels */}
        <div className="absolute left-[85px] bottom-1 w-[72px] h-[72px] bg-[url('https://pngimg.com/uploads/car_wheel/car_wheel_PNG23306.png')] bg-center bg-contain animate-wheel-rotate z-40"></div>
        <div className="absolute right-[85px] bottom-1 w-[72px] h-[72px] bg-[url('https://pngimg.com/uploads/car_wheel/car_wheel_PNG23306.png')] bg-center bg-contain animate-wheel-rotate z-40"></div>

        {/* Shadow */}
        <div className="absolute bottom-[-15px] left-0 w-full h-[20px] bg-black/30 rounded-full blur-sm scale-y-50 animate-shadow-bounce z-20"></div>
      </div>
    </section>
  );
};

export default CarAnimation;
